// 孕育周知
// 所有page请放在 /user/page/knowing目录下
const KnowingIndex = () => import('../page/knowing/index/index.page');
const KnowingReceive = () => import('../page/knowing/receive/index.page');
const KnowingDetail = () => import('../page/knowing/detail/index.page');

export default [
  {
    path: '/knowing/receive/:weeklyId(weeklyId-\\d+)/:shareCode(shareCode-\\S+)',
    name: 'knowingReceive',
    meta: {
      pageTitle: '孕育周知',
      requiresAuth: false        // 是否需要登录
    },
    component: KnowingReceive
  },
  {
    path: '/knowing/detail/:weeklyId(weeklyId-\\d+)',
    name: 'knowingDetail',
    meta: {
      pageTitle: '孕育周知',
      requiresAuth: false        // 是否需要登录
    },
    component: KnowingDetail
  },
  {
    path: '/knowing/rights',
    name: 'knowingRights',
    meta: {
      pageTitle: '孕育周知',
      desc: '免费领取',
      requiresAuth: true        // 是否需要登录
    },
    component: () => import('../page/knowing/legal/index.page')
  },
  {
    path: '/knowing/coupon',
    name: 'knowingCoupon',
    meta: {
      pageTitle: '孕育周知',
      desc: '我要兑换',
      requiresAuth: true        // 是否需要登录
    },
    component: () => import('../page/knowing/legal/index.page')
  },
  {
    path: '/knowing/index',
    name: 'knowingIndex',
    meta: {
      pageTitle: '孕育周知',
      requiresAuth: false        // 是否需要登录
    },
    component: KnowingIndex
  }
];



// WEBPACK FOOTER //
// ./src/user/router/knowing.js